import { Form, Formik } from "formik";

const FormikComponent = (props) => {
	const { children, validationSchema, initialValues, onSubmit } = props;
	return (
		<Formik
			initialValues={initialValues}
			validationSchema={validationSchema}
			onSubmit={onSubmit}
		>
			<Form>{children}</Form>
		</Formik>
	);
};

export default FormikComponent;
